<template>
<div class="box">
  <div class="mask-box"></div>
  <div class="querter-box">
    <el-amap-search-box class="search-box" style="position: absolute;top: 20px;" :search-option="searchOption" :on-search-result="onSearchResult"></el-amap-search-box>
    <el-amap vid="amapDemo" :center="mapCenter" :amap-manager="amapManager" :plugin="plugins" :zoom="zoom" :events="events" class="amap-demo">
      <el-amap-marker v-for="(marker, index) in markers" :key="index" :position="marker" ></el-amap-marker>
    </el-amap>
    <div style="overflow:auto;height:50px;">
      <!-- 此处循环, 后端返回的 数组 -->
      <!-- <div @click="checkItem(item)" v-for="(item,index) in pointLists" > -->
        <div>
          <h4 style="color:#000;font-weight:400;font-size:17px;">{{tempObj.address}}</h4>
          <!-- <span style="color:#B1A6A6;font-weight:400;margin-bottom:3px;font-size:14px;">{{item.address}}</span> -->
        </div>
      <!-- </div> -->
    </div>

    <div class="pop-footBtn">
      <el-button @click="close" size="small">关闭</el-button>
      <el-button type="warning" size="small" @click="addAddress">保存</el-button>
    </div>

  </div>
</div>
</template>
<script>
import Vue from 'vue'
import VueAMap from 'vue-amap'
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: 'a53fcb984e3b2e4a7758c7a83b75c4ad',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.Geolocation', 'AMap.Geocoder', 'AMap.AMapManager', 'AMap.Marker'],
  uiVersion: '1.0',
  v: '1.4.4'
})
let amapManager = new VueAMap.AMapManager()
export default {
  data: function () {
    let self = this
    return {
      markers: [],
      amapManager,
      zoom: 12,
      tempObj: {},
      plugins: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.Geolocation', 'AMap.Geocoder', 'AMap.AMapManager', 'AMap.Marker'],
      searchOption: {},
      mapCenter: [121.59996, 31.197646],
      events: {
        'click': (e) => {
          let { lng, lat } = e.lnglat
          self.lng = lng
          self.lat = lat
          this.setAddress(lng, lat)
        }
      }
    }
  },
  mounted () {
    console.log(this.address, 'this.address')
    if (this.address && ((this.address.point && this.address.point[0] && this.address.point[1]) || this.address.location)) {
      if (this.address.point && this.address.point[0] && this.address.point[1]) {
        let lng = this.address.point[0]
        let lat = this.address.point[1]
        this.mapCenter = this.address.point
        this.setAddress(lng, lat)
      } else if (this.address.location) {
        let point = this.address.location.split(',')
        let lng = parseFloat(point[0])
        let lat = parseFloat(point[1])
        this.mapCenter = [parseFloat(point[0]), parseFloat(point[1])]
        this.setAddress(lng, lat)
      }
    }
  },
  props: ['address'],
  methods: {
    setAddress (lng, lat) {
      let self = this
      // 这里通过高德 SDK 完成。
      var geocoder = new AMap.Geocoder({
        radius: 1000,
        extensions: 'all'
      })
      geocoder.getAddress([lng, lat], function (status, result) {
        if (status === 'complete' && result.info === 'OK') {
          if (result && result.regeocode) {
            self.removeMarker()
            self.markers.push([lng, lat])
            self.tempObj.address = result.regeocode.formattedAddress
            self.$nextTick()
            var item = {
              check: false,
              province: result.regeocode.addressComponent.province,
              city: result.regeocode.addressComponent.city,
              county: result.regeocode.addressComponent.district,
              name: result.regeocode.formattedAddress,
              addressLocation: result.regeocode.formattedAddress,
              address: result.regeocode.formattedAddress,
              location: lng + ',' + lat
            }
            self.tempObj = item
          }
        }
      })
    },
    removeMarker () {
      if (!this.markers.length) return
      this.markers = []
    },
    onSearchResult (pois) {
      this.removeMarker()
      let latSum = 0
      let lngSum = 0
      if (pois.length > 0) {
        pois.forEach(poi => {
          let {lng, lat} = poi
          lngSum += lng
          latSum += lat
          this.markers.push([poi.lng, poi.lat])
        })
        let center = {
          lng: lngSum / pois.length,
          lat: latSum / pois.length
        }
        let poi = pois[0]
        let {lng, lat} = poi
        this.setAddress(lng, lat)
        this.mapCenter = [center.lng, center.lat]
      }
    },
    close () {
      this.address.addressVisible = false
    },
    addAddress () {
      if (this.tempObj.location === undefined) {
        this.util.error('请选择一个地点！')
        return
      }
      var location = this.tempObj.location
      var province = this.tempObj.province
      var city = this.tempObj.city
      var county = this.tempObj.county
      this.address.addressVisible = false
      this.$emit('chooseAddress', {address: this.tempObj.address, addressLocation: location, province: province, city: city, county: county})
    }
  }
}
</script>

<style>
  .el-vue-amap-container, .el-vue-amap-container .el-vue-amap {
      height: 97%!important;
  }

  .amap-page-container {
    margin-top: -40px;
    width: 100%;
    height: 100%;
    position: relative;
  }
</style>
<style scoped>
/* .head,.mymap{
position: absolute;
top: 0;
left: 0;
width: 100%;
} */
span:before {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR…f81+TuKpc3NI9dzSb6ylk1k/9Cm+krTnka/mxKvXW5Ufs3VqBHBb9drYAAAAAASUVORK5CYII=) no-repeat 0 0;
  position: absolute;
  content: "";
  left: 0;
  width: 22px;
  height: 22px;
  top: 1px;
}
.mask-box{
    width: 100%;height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3099;
}
.querter-box{
    width: 1060px;
    transform: translate(-50%,-50%);
    position: fixed;
		padding: 20px;
    left: 50%;
    top: 50%;
    background: #fff;
    border-radius: 5px ;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);
    height: 600px;
    z-index: 3100;
    overflow: hidden;
    color: #333;
    text-align: left
}

.pop-footBtn{
  position: absolute;
  bottom: 3px;
  right: 20px;
  height: 45px;
  line-height: 45px;
}
.mymap{
	/* top: 44px; */
	height: 460px;
	margin-top: 10px;
}
.icon-success{
	position: absolute;
	left: 3px;
  top: 14px;
}
.icon-success::before{
	margin:0!important;
}
/* #check-my-map .el-radio{
	position: relative
}
#check-my-map .el--radio__input{
	position: absolute;
    left: -23px;
    top: 21px;
}
#check-my-map .el-radio__label{
	display: block;
	padding-top:15px;
} */
</style>



// WEBPACK FOOTER //
// src/common/form/map/index.vue